import { sendDmMessageMutationFn, sendGroupMessageMutationFn } from '../../api/write/messages';
import { groupMembershipMutationFn } from '../../api/write/groupMembership';
import { followWriteMutationFn } from '../../api/write/follow';
import { rsvpWriteMutationFn } from '../../api/write/rsvp';
import { createOfflineMutationOptions } from './offlineMutationOptions';

/** Register mutationFn defaults so persisted paused mutations can resume after app restart. */
export function registerMutationDefaults(queryClient) {
  queryClient.setMutationDefaults(['mutations', 'messages', 'send', 'dm'], {
    ...createOfflineMutationOptions(),
    mutationFn: sendDmMessageMutationFn,
  });

  queryClient.setMutationDefaults(['mutations', 'messages', 'send', 'group'], {
    ...createOfflineMutationOptions(),
    mutationFn: sendGroupMessageMutationFn,
  });

  queryClient.setMutationDefaults(['mutations', 'rsvp'], {
    ...createOfflineMutationOptions(),
    mutationFn: rsvpWriteMutationFn,
  });

  queryClient.setMutationDefaults(['mutations', 'groupMembership'], {
    ...createOfflineMutationOptions(),
    mutationFn: groupMembershipMutationFn,
  });

  queryClient.setMutationDefaults(['mutations', 'follow'], {
    ...createOfflineMutationOptions(),
    mutationFn: followWriteMutationFn,
  });
}
